import React from 'react';
import Col from 'antd/es/col';
import Icon from 'antd/es/icon';
import Row from 'antd/es/row';

const Loader = () => {
  return (
      <Row>
        <Col span={24}>
          <h3 className="text-center">
            <Icon type="loading" className="mc-mr-10 mc-mtb-30"/> Loading...
          </h3>
        </Col>
      </Row>
  );
};

export {Loader};
